<template>
  <div class="table-outer">
    <div class="table-fixed table-fixed-left" ref="fixedLeft" :style="{ width: leftWidth + 'px', left: 0, zIndex: 20 }"
      v-if="leftColumns.length">
      <div class="table-header-row" :class="{ 'sticky-header': stickyHeader }" ref="fixedLeftHeader">
        <div v-for="col in leftColumns" :key="col.key" class="header-cell"
          :class="{ 'action-header': col.key === 'action' }" :style="{ width: col.width }">
          <slot :name="'header-' + col.key" :column="col">{{ col.title }}</slot>
        </div>
      </div>
      <div class="table-body" ref="leftBody">
        <div v-for="(row, rowIndex) in data" :key="rowIndex" class="table-row" @click="handleRowClick(row, rowIndex)">
          <div v-for="col in leftColumns" :key="col.key" class="table-cell"
            :class="{ 'action-cell': col.key === 'action' }" :style="{ width: col.width }">
            <slot :name="'cell-' + col.key" :row="row" :column="col" :rowIndex="rowIndex">
              <div class="cell-content-wrapper" :class="{ 'ellipsis-cell': col.width && showTooltip }"
                @click="handleCellClick($event, row[col.key], col.key)">
                <span class="cell-text">{{ row[col.key] }}</span>
                <span v-if="col.width && showTooltip" class="ellipsis-dots">...</span>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>

    <div class="table-scrollable" ref="scrollable" @scroll="handleScroll" :style="{
      marginLeft: leftWidth + 'px',
      marginRight: rightWidth + 'px',
    }">
      <div :style="{ minWidth: mainColumnsWidth + 'px' }">
        <div class="table-header-row" :class="{ 'sticky-header': stickyHeader }">
          <div v-for="col in mainColumnsWithWidth" :key="col.key" class="header-cell"
            :class="{ 'action-header': col.key === 'action' }" :style="{ width: col.width }">
            <slot :name="'header-' + col.key" :column="col">{{ col.title }}</slot>
          </div>
        </div>
        <div class="table-body" ref="mainBody">
          <div v-for="(row, rowIndex) in data" :key="rowIndex" class="table-row" @click="handleRowClick(row, rowIndex)">
            <div v-for="col in mainColumnsWithWidth" :key="col.key" class="table-cell"
              :class="{ 'action-cell': col.key === 'action' }" :style="{ width: col.width }">
              <slot :name="'cell-' + col.key" :row="row" :column="col" :rowIndex="rowIndex">
                <div class="cell-content-wrapper" :class="{ 'ellipsis-cell': col.width && showTooltip }"
                  @click="handleCellClick($event, row[col.key], col.key)">
                  <span class="cell-text">{{ row[col.key] }}</span>
                  <span v-if="col.width && showTooltip" class="ellipsis-dots">...</span>
                </div>
              </slot>
            </div>
          </div>
          <div v-if="data.length === 0 && !loading" class="empty-state">
            <div class="empty-icon">📊</div>
            <div class="empty-text">暂无数据</div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-fixed table-fixed-right" ref="fixedRight"
      :style="{ width: rightWidth + 'px', right: 0, zIndex: 30 }" v-if="rightColumns.length">
      <div class="table-header-row" :class="{ 'sticky-header': stickyHeader }" ref="fixedRightHeader">
        <div v-for="col in rightColumns" :key="col.key" class="header-cell"
          :class="{ 'action-header': col.key === 'action' }" :style="{ width: col.width }">
          <slot :name="'header-' + col.key" :column="col">{{ col.title }}</slot>
        </div>
      </div>
      <div class="table-body" ref="rightBody">
        <div v-for="(row, rowIndex) in data" :key="rowIndex" class="table-row" @click="handleRowClick(row, rowIndex)">
          <div v-for="col in rightColumns" :key="col.key" class="table-cell no-row-hover"
            :class="{ 'action-cell': col.key === 'action' }" :style="{ width: col.width }">
            <slot :name="'cell-' + col.key" :row="row" :column="col" :rowIndex="rowIndex" :onAction="onAction">
              <template v-if="col.actions && Array.isArray(col.actions)">
                <div class="action-buttons-wrapper">
                  <button v-for="action in col.actions" :key="action" @click.stop="onAction(action, row, rowIndex)"
                    class="action-btn">{{ actionMap[action] || action }}</button>
                </div>
              </template>
              <span v-else>{{ row[col.key] }}</span>
            </slot>
          </div>
        </div>
      </div>
    </div>

    <div v-if="hasMore || loading" class="load-more">
      <div v-if="loading" class="loading">
        <div class="loading-spinner"></div>
        <span>加载中...</span>
      </div>
      <div v-else class="load-more-btn" @click="handleLoadMore">
        点击加载更多
      </div>
    </div>
    <div v-else-if="data.length > 0" class="no-more">
      <span>没有更多数据了</span>
    </div>

    <!-- <div v-if="tooltipVisible && showTooltip" class="tooltip" :class="{ 'show': tooltipVisible }" :style="{
      left: tooltipPosition.x + 'px',
      top: tooltipPosition.y + 'px'
    }" @click.stop="hideTooltip">
      <div class="tooltip-content">
        {{ tooltipContent }}
      </div>
      <div class="tooltip-arrow"></div>
    </div> -->
    <!-- 替换原来的 tooltip DOM -->
    <div v-if="tooltipVisible && showTooltip" class="tooltip"
      :class="[{ 'show': tooltipVisible }, tooltipPlacement === 'below' ? 'tooltip--below' : 'tooltip--above']" :style="{
        left: tooltipPosition.x + 'px',
        top: tooltipPosition.y + 'px'
      }" @click.stop="/* 点击 tooltip 本身不关闭 */">
      <div class="tooltip-content">
        {{ tooltipContent }}
      </div>
      <!-- 箭头 left 由 JS 动态设置（px），CSS 用 translateX(-50%) 保证居中基于该坐标 -->
      <div class="tooltip-arrow" :style="{ left: tooltipArrowLeft + 'px' }"></div>
    </div>
  </div>
</template>

<script>
function parsePx(val) {
  if (typeof val === 'number') return val
  if (typeof val === 'string' && val.endsWith('px')) return parseInt(val)
  return Number(val) || 0
}
export default {
  name: 'MobileTablePro',
  props: {
    columns: {
      type: Array,
      required: true,
      default: () => []
    },
    data: {
      type: Array,
      required: true,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Boolean,
      default: true
    },
    stickyHeader: {
      type: Boolean,
      default: true
    },
    showTooltip: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tableWidth: 0,
      // MODIFIED: 添加 headerHeight 用于动态计算
      headerHeight: 36, // 给一个默认值
      actionMap: {
        detail: '详情',
        edit: '编辑',
        delete: '删除'
      },
      tooltipVisible: false,
      tooltipContent: '',
      tooltipPosition: { x: 0, y: 0 },
      tooltipArrowLeft: 0,           // 新增：箭头在 tooltip 内的 px 位置（以 tooltip 左边为 0）
      tooltipPlacement: 'above',    // 'above' or 'below'
      clickListener: null,
      tooltipTimer: null,
      // 新增：记录当前显示 tooltip 的元素（DOM 节点）
      currentTooltipCell: null,
    }
  },
  computed: {
    leftColumns() {
      return this.columns.filter(col => col.fixed === 'left')
    },
    rightColumns() {
      return this.columns.filter(col => col.fixed === 'right')
    },
    mainColumns() {
      return this.columns.filter(col => !col.fixed)
    },
    leftWidth() {
      return this.leftColumns.reduce((sum, col) => sum + parsePx(col.width), 0)
    },
    rightWidth() {
      return this.rightColumns.reduce((sum, col) => sum + parsePx(col.width), 0)
    },
    mainColumnsWithWidth() {
      const mainCols = this.mainColumns
      const mainAreaWidth = Math.max(this.tableWidth - this.leftWidth - this.rightWidth, 0)
      const mainFixedWidth = mainCols
        .map(col => col.width ? parsePx(col.width) : 0)
        .reduce((a, b) => a + b, 0)
      const unsetMainCols = mainCols.filter(col => !col.width)
      const remain = Math.max(mainAreaWidth - mainFixedWidth, 0)
      const avg = unsetMainCols.length ? Math.floor(remain / unsetMainCols.length) : 0
      return mainCols.map(col => ({
        ...col,
        width: col.width || (avg ? `${avg}px` : '100px')
      }))
    },
    mainColumnsWidth() {
      return this.mainColumnsWithWidth.reduce((sum, col) => sum + parsePx(col.width), 0)
    },
    allColumnsWithWidth() {
      return [
        ...this.leftColumns,
        ...this.mainColumnsWithWidth,
        ...this.rightColumns
      ]
    }
  },
  watch: {
    // MODIFIED: Watcher现在也重置marginTop
    stickyHeader(isSticky) {
      if (isSticky) {
        // 当表头变为粘性时，重置所有 transform 和 margin
        if (this.$refs.fixedLeftHeader) {
          this.$refs.fixedLeftHeader.style.transform = 'translateY(0px)';
          this.$refs.leftBody.style.marginTop = '0px';
        }
        if (this.$refs.fixedRightHeader) {
          this.$refs.fixedRightHeader.style.transform = 'translateY(0px)';
          this.$refs.rightBody.style.marginTop = '0px';
        }
      }
    }
  },
  mounted() {
    this.calcTableWidth()
    window.addEventListener('resize', this.calcTableWidth)
    this.$nextTick(() => {
      this.checkEllipsis()
    })
    this.$emit('load')
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableWidth)
    if (this.clickListener) {
      document.removeEventListener('click', this.clickListener)
    }
    if (this.tooltipTimer) {
      clearTimeout(this.tooltipTimer)
      this.tooltipTimer = null
    }
  },
  updated() {
    this.$nextTick(() => {
      this.checkEllipsis()
    })
  },
  methods: {
    handleRowClick(row, rowIndex) {
      this.$emit('row-click', row, rowIndex)
    },
    handleLoadMore() {
      if (!this.loading && this.hasMore) {
        this.$emit('load-more')
      }
    },
    // MODIFIED: handleScroll 现在同时处理 body 的 marginTop
    handleScroll(e) {
      const scrollTop = e.target.scrollTop

      // 1. 同步所有表格体的纵向滚动
      if (this.$refs.leftBody) this.$refs.leftBody.scrollTop = scrollTop
      if (this.$refs.rightBody) this.$refs.rightBody.scrollTop = scrollTop

      // 2. 如果表头不是粘性的，则处理滚动效果
      if (!this.stickyHeader) {
        // 计算body需要向上移动的距离，最多不超过一个表头的高度
        const offset = Math.min(scrollTop, this.headerHeight);

        // 处理左固定列
        if (this.$refs.fixedLeftHeader) {
          // 移动表头
          this.$refs.fixedLeftHeader.style.transform = `translateY(-${scrollTop}px)`;
          // 移动表体以填充空白
          this.$refs.leftBody.style.marginTop = `-${offset}px`;
        }
        // 处理右固定列
        if (this.$refs.fixedRightHeader) {
          this.$refs.fixedRightHeader.style.transform = `translateY(-${scrollTop}px)`;
          this.$refs.rightBody.style.marginTop = `-${offset}px`;
        }
      }
    },
    // MODIFIED: calcTableWidth 现在也获取表头高度
    calcTableWidth() {
      this.$nextTick(() => {
        this.tableWidth = this.$el.offsetWidth || 0;
        // 动态获取表头高度，使其更健壮
        const headerEl = this.$el.querySelector('.table-header-row');
        if (headerEl) {
          this.headerHeight = headerEl.offsetHeight;
        }
      })
    },
    onAction(action, row, rowIndex) {
      this.$emit('action', action, row, rowIndex)
    },
    handleCellClick(event, content) {
      if (!this.showTooltip) return;

      const cell = event.currentTarget;
      const cellText = cell.querySelector('.cell-text');

      // 是否需要 tooltip（超出才显示）
      const needTooltip = cellText && cellText.scrollWidth > cellText.clientWidth;

      if (!needTooltip) {
        // 点击不可展示 tooltip 的元素 => 关闭现有 tooltip（如果有）
        if (this.tooltipVisible) {
          this.hideTooltip();
        }
        return;
      }

      // 点击的是当前已打开 tooltip 的同一个元素 => 不重复处理
      if (this.tooltipVisible && this.currentTooltipCell === cell) {
        return;
      }

      // 如果已有 tooltip 且点击了另一个可展示的 cell，我们需要立即切换：
      // 立刻清理旧 tooltip 的监听和定时器，避免冲突（不会等动画完成）
      if (this.tooltipVisible && this.currentTooltipCell && this.currentTooltipCell !== cell) {
        this._closeImmediate();
      }

      // 记录当前 cell 引用
      this.currentTooltipCell = cell;
      this.tooltipContent = content;

      // 先把 tooltip 标记为可见（使 DOM 渲染出来），并初步设置 x（以目标中心为基准）
      const rect = cell.getBoundingClientRect();
      const targetCenter = rect.left + rect.width / 2;
      // 先用 targetCenter 作为初始 center x
      this.tooltipPosition.x = targetCenter;
      // 临时把 tooltip 放到元素下方，避免初次测量时出现遮挡（位置会在 nextTick 中修正）
      this.tooltipPosition.y = rect.bottom + 10;
      this.tooltipVisible = true;

      this.$nextTick(() => {
        const tooltipEl = this.$el.querySelector('.tooltip');
        if (!tooltipEl) return;

        const tooltipRect = tooltipEl.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const tooltipWidth = tooltipRect.width;
        const tooltipHeight = tooltipRect.height;

        // 1) 根据实际宽度检测并修正 center x（避免溢出）
        let x = targetCenter;
        // const leftGap = tooltipWidth / 2 + 10; // 最小留白 10px + half width
        // 若 tooltip 左边会溢出视口，则向右移动 center
        if (x - tooltipWidth / 2 < 10) {
          x = 10 + tooltipWidth / 2;
        }
        // 若 tooltip 右边会溢出视口，则向左移动 center
        if (x + tooltipWidth / 2 > viewportWidth - 10) {
          x = viewportWidth - 10 - tooltipWidth / 2;
        }

        // 2) 计算纵向位置：优先放在元素上方，否则放在下方
        let y;
        let placement;
        if (rect.top - tooltipHeight - 10 >= 0) {
          // 上方有足够空间
          y = rect.top - tooltipHeight - 10;
          placement = 'above';
        } else {
          // 放下方
          y = rect.bottom + 10;
          placement = 'below';
        }

        // 更新位置/放置方向
        this.tooltipPosition = { x, y };
        this.tooltipPlacement = placement;

        // 3) 计算箭头在 tooltip 内的 left（px）
        // tooltipLeft = tooltip center x - tooltipWidth/2
        const tooltipLeft = x - tooltipWidth / 2;
        let arrowLeft = targetCenter - tooltipLeft; // 目标中心相对于 tooltip 左边的像素坐标

        // 边界夹紧：避免箭头贴到极端边缘（保留 8px 空隙）
        const minArrow = 8;
        const maxArrow = Math.max(tooltipWidth - 8, minArrow);
        arrowLeft = Math.max(minArrow, Math.min(arrowLeft, maxArrow));

        this.tooltipArrowLeft = Math.round(arrowLeft);

        // 4) 绑定 document 点击监听（延迟绑定以避免当前点击立刻触发）
        if (this.clickListener) {
          document.removeEventListener('click', this.clickListener);
          this.clickListener = null;
        }

        this.clickListener = (e) => {
          const tooltipDom = this.$el.querySelector('.tooltip');
          // 点击 tooltip 内部 => 不关闭
          if (tooltipDom && tooltipDom.contains(e.target)) return;

          // 点击某个 cell => 交给 cell click 处理（不在此处关闭）
          const clickedCell = e.target.closest('.cell-content-wrapper');
          if (clickedCell) return;

          // 其它区域 => 关闭
          this.hideTooltip();
        };

        setTimeout(() => {
          document.addEventListener('click', this.clickListener);
        }, 10);

        // 5) 2 秒自动关闭（每次打开都重置）
        if (this.tooltipTimer) clearTimeout(this.tooltipTimer);
        this.tooltipTimer = setTimeout(() => {
          this.hideTooltip();
        }, 2000);
      });
    },
    _closeImmediate() {
      if (this.clickListener) {
        document.removeEventListener('click', this.clickListener);
        this.clickListener = null;
      }
      if (this.tooltipTimer) {
        clearTimeout(this.tooltipTimer);
        this.tooltipTimer = null;
      }
      // 立即隐藏 tooltip（同步）
      this.tooltipVisible = false;
      this.tooltipContent = '';
      this.tooltipPosition = { x: 0, y: 0 };
      this.tooltipArrowLeft = 0;
      this.tooltipPlacement = 'above';
      this.currentTooltipCell = null;
    },
    hideTooltip() {
      if (!this.tooltipVisible) return;

      // 隐藏（reactive）
      this.tooltipVisible = false;

      // 清理监听与计时器（同步）
      if (this.clickListener) {
        document.removeEventListener('click', this.clickListener);
        this.clickListener = null;
      }
      if (this.tooltipTimer) {
        clearTimeout(this.tooltipTimer);
        this.tooltipTimer = null;
      }

      // 延迟清空内容以保留 CSS 的淡出动画（150ms）
      setTimeout(() => {
        this.tooltipContent = '';
        this.tooltipPosition = { x: 0, y: 0 };
        this.tooltipArrowLeft = 0;
        this.tooltipPlacement = 'above';
        this.currentTooltipCell = null;
      }, 150);
    },
    checkEllipsis() {
      if (!this.showTooltip) return

      const cells = this.$el.querySelectorAll('.cell-content-wrapper')
      cells.forEach(cell => {
        const cellText = cell.querySelector('.cell-text')
        const ellipsisDots = cell.querySelector('.ellipsis-dots')

        if (cellText && ellipsisDots) {
          if (cellText.scrollWidth > cellText.clientWidth) {
            ellipsisDots.style.display = 'inline'
          } else {
            ellipsisDots.style.display = 'none'
          }
        }
      })
    },

    debugTooltip() {
      console.log('Tooltip state:', {
        visible: this.tooltipVisible,
        content: this.tooltipContent,
        position: this.tooltipPosition,
        clickListener: !!this.clickListener
      })
    }
  }
}
</script>

<style scoped>
/* CSS 样式部分保持不变 */
.table-outer {
  position: relative;
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  box-sizing: border-box;
  z-index: 0;
  padding: 0;
  z-index: 500;
}

.table-fixed {
  position: absolute;
  top: 0;
  bottom: 0;
  background: white;
  display: flex;
  flex-direction: column;
  min-width: 0;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  z-index: 10;
  overflow: hidden;
}

.table-fixed-right {
  right: 0;
  box-shadow: -2px 0 4px rgba(0, 0, 0, 0.08);
  z-index: 30;
  overflow: hidden;
}

.table-scrollable {
  position: relative;
  flex: 1;
  overflow-x: auto;
  overflow-y: auto;
  min-width: 0;
  height: 100%;
  box-sizing: border-box;
  z-index: 5;
}

.table-header-row {
  display: flex;
  min-width: 100%;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  left: 0;
  right: 0;
  /* MODIFIED: add transition for smoother reset */
  transition: transform 0.1s ease-out;
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 20;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  left: 0;
  right: 0;
}

.header-cell {
  padding: 8px 4px;
  font-weight: 600;
  font-size: 14px;
  color: #495057;
  background: #f8f9fa;
  border-right: 1px solid #e9ecef;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 36px;
}

.table-body {
  flex: 1;
  overflow: hidden;
  box-sizing: border-box;
}

.table-row {
  display: flex;
  min-width: 100%;
  border-bottom: 1px solid #f1f3f4;
  transition: background-color 0.2s;
  box-sizing: border-box;
}

.table-row:hover {
  background-color: #f8f9fa;
}

.table-row:active {
  background-color: #e9ecef;
}

.table-cell {
  padding: 8px 4px;
  font-size: 14px;
  color: #212529;
  border-right: 1px solid #f1f3f4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 36px;
}

.cell-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #6c757d;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.empty-text {
  font-size: 16px;
}

.load-more {
  padding: 10px;
  text-align: center;
  background: white;
  border-top: 1px solid #e9ecef;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  font-size: 14px;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #e9ecef;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.load-more-btn {
  padding: 12px 24px;
  background: #007bff;
  color: white;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: inline-block;
}

.load-more-btn:hover {
  background: #0056b3;
}

.load-more-btn:active {
  background: #004085;
}

.no-more {
  padding: 10px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
  background: white;
  border-top: 1px solid #e9ecef;
}

@media (max-width: 768px) {
  .table-outer {
    border-radius: 4px;
  }

  .header-cell,
  .table-cell {
    padding: 10px 6px;
    font-size: 13px;
  }

  .load-more-btn {
    padding: 10px 20px;
    font-size: 13px;
  }
}

.table-row {
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
}

.table-header-row,
.table-row {
  width: 100%;
  min-width: 100%;
}

.action-btn {
  margin-right: 0;
  padding: 2px 4px;
  font-size: 10px;
  border: 1px solid #d1d5db;
  background: #f8f9fa;
  border-radius: 2px;
  cursor: pointer;
  transition: background 0.2s;
  line-height: 1.1;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  white-space: nowrap;
}

.action-btn:hover {
  background: #e6f0ff;
  border-color: #409eff;
  color: #409eff;
}

.table-row .no-row-hover {
  background: inherit !important;
}

.table-row:hover .no-row-hover,
.table-row:active .no-row-hover {
  background: inherit !important;
}

/* 操作列特殊样式 */
.action-cell {
  justify-content: center;
  align-items: center;
  padding: 8px 4px;
  height: 36px;
  width: 100%;
  margin: 0;
  border: none;
  text-align: center;
  display: flex;
  overflow: hidden;
}

.action-cell .action-btn {
  justify-content: center;
  align-items: center;
}

.action-header {
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 8px 4px;
  height: 36px;
  margin: 0;
  border: none;
  text-align: center;
  display: flex;
  overflow: hidden;
}

.action-buttons-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  width: 100%;
  margin: 0;
  padding: 0;
  flex-wrap: nowrap;
  overflow: hidden;
}

/* 确保所有表格单元格都有相同的对齐方式 */
.table-cell,
.header-cell {
  text-align: center;
}

/* 确保表格行的对齐方式一致 */
.table-row,
.table-header-row {
  align-items: stretch;
}

/* 确保固定列的对齐方式一致 */
.table-fixed .table-cell,
.table-fixed .header-cell {
  text-align: center;
  justify-content: center;
}

/* 确保操作列的对齐方式完全一致 */
.table-fixed-right .action-cell,
.table-fixed-right .action-header {
  text-align: center;
  justify-content: center;
  align-items: center;
}

/* 强制操作列内容居中 */
.table-fixed-right .action-cell .action-buttons-wrapper {
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

/* 确保所有表格行高度一致 */
.table-row {
  height: 36px;
  align-items: stretch;
}

/* 确保表格单元格内容垂直居中 */
.table-cell>*,
.header-cell>* {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: hidden;
}

/* 确保操作列内容不超出单元格高度 */
.action-cell,
.action-header {
  max-height: 36px;
  overflow: hidden;
}

.action-buttons-wrapper {
  max-height: 100%;
  overflow: hidden;
}

/* 确保表头区域完全覆盖 */
.table-header-row.sticky-header {
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* 确保表格容器完全覆盖 */
.table-outer {
  background: white;
  border: 1px solid #e9ecef;
  position: relative;
  overflow: hidden;
}

/* 确保固定列完全覆盖 */
.table-fixed,
.table-fixed-right {
  background: white;
  border: none;
}

/* 确保所有表格区域都有正确的背景 */
.table-scrollable {
  background: white;
}

.table-body {
  background: white;
}

/* 单元格内容包装器 */
.cell-content-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.cell-content-wrapper:hover {
  background-color: rgba(0, 123, 255, 0.05);
}

.cell-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ellipsis-cell {
  position: relative;
}

.ellipsis-cell:hover {
  background-color: rgba(0, 123, 255, 0.02);
}

.ellipsis-dots {
  color: #007bff;
  font-weight: bold;
  margin-left: 4px;
  display: none;
  cursor: pointer;
  font-size: 12px;
  background: rgba(0, 123, 255, 0.1);
  padding: 1px 3px;
  border-radius: 2px;
  transition: all 0.2s ease;
}

.ellipsis-cell:hover .ellipsis-dots {
  background: rgba(0, 123, 255, 0.2);
  color: #0056b3;
}

/* Tooltip样式 */
.tooltip {
  position: fixed;
  z-index: 999999;
  pointer-events: auto;
  transform: translateX(-50%) scale(0.95);
  opacity: 0;
  transition: all 0.15s ease-out;
}

.tooltip.show {
  opacity: 1;
  transform: translateX(-50%) scale(1);
}

.tooltip-content {
  background: #2c3e50;
  color: white;
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 13px;
  max-width: 250px;
  word-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.tooltip-arrow {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #2c3e50;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}
</style>
